export const REQUIRED_FIELDS = {
  simple: ["value"],
  simpleLongText: ["value"],
  value: ["value"],
  valueUnit: ["value", "valueUnit"],
  valueUnitDenominator: ["value", "valueUnit"],
  yearValue: ["unit", "value"],
  yearValueUnit: ["unit", "value", "valueUnit"],
  yearValueCategory: ["unit", "value", "category"],
  yearLocationValueUnit: ["unit", "value", "location", "valueUnit"],
};

export const FIELD_LABELS = {
  value: "Value",
  valueUnit: "Unit",
  unit: "Year",
  location: "Location",
  category: "Category",
};
